// extracted by mini-css-extract-plugin
export default {"wrapper":"_3WU7j","hidden":"q_o7l","buttonContainer":"BWSlc","button":"hP-AY"};